var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLink = function SvgIconLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.642 12.642a.908.908 0 0 1 1.285 1.285l-2.141 2.14a2.12 2.12 0 0 1-2.997 0l-4.282-4.281a5.147 5.147 0 1 1 7.279-7.279l.166.167a.908.908 0 1 1-1.284 1.284l-.166-.166a3.33 3.33 0 1 0-4.71 4.71l4.281 4.281c.119.118.31.118.428 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.358 11.358a.908.908 0 0 1-1.285-1.285l2.141-2.14a2.12 2.12 0 0 1 2.997 0l4.282 4.281a5.147 5.147 0 0 1-7.279 7.279l-.166-.167a.908.908 0 0 1 1.284-1.284l.166.166a3.33 3.33 0 1 0 4.71-4.71l-4.281-4.281a.303.303 0 0 0-.428 0z"
  })));
};
export default SvgIconLink;